module.exports = __webpack_public_path__ + "static/media/Homenagem Antigos Professores de direito -2014.d13fa7af.jpg";